import { useQuery } from '@tanstack/react-query';
import { truktApi, GetOrdersResponse } from '@api';
import { AxiosError } from 'axios';
import { CustomError } from '@trukt/portal-utils/Error';

import { QUERY_CACHE_IDS_MAP } from '@types';
import {
  UseOrdersQueryOptions,
  UseOrdersQueryProps,
  UseOrdersQueryResult,
} from './useOrdersQuery.types';

export const useOrdersQuery = (
  request: UseOrdersQueryProps,
  options?: UseOrdersQueryOptions,
  aditionalKey?: string,
): UseOrdersQueryResult => {
  const queryKey: unknown[] = [QUERY_CACHE_IDS_MAP.ORDER_LIST, request];
  if (aditionalKey) queryKey.push(aditionalKey);

  const query = useQuery<GetOrdersResponse, AxiosError<CustomError>>({
    queryKey,
    queryFn: async () => {
      const response = await truktApi.order.getOrders(request);
      return response.data;
    },
    ...options,
  });

  return query;
};
